/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class HttpHandlerService {

        httpService: ng.IHttpService;
        handlerUrl: string;

        constructor($http: ng.IHttpService) {
            this.httpService = $http;
        }

        protected useGetHandler(params: any): ng.IPromise<any> {
            var result: ng.IPromise<any> = this.httpService.get(this.handlerUrl, params)
                .then((response: any): ng.IPromise<any> => this.handlerResponded(response, params));
            return result;
        }

        protected usePostHandler(params: any): ng.IPromise<any> {
            var result: ng.IPromise<any> = this.httpService.post(this.handlerUrl, params)
                .then((response: any): ng.IPromise<any> => this.handlerResponded(response, params));
            return result;
        }

        protected usePutHandler(params: any): ng.IPromise<any> {
            var result: ng.IPromise<any> = this.httpService.put(this.handlerUrl, params)
                .then((response: any): ng.IPromise<any> => this.handlerResponded(response, params));
            return result;
        }

        protected useDeleteHandler(params: any): ng.IPromise<any> {
            var result: ng.IPromise<any> = this.httpService.delete(this.handlerUrl, params)
                .then((response: any): ng.IPromise<any> => this.handlerResponded(response, params));
            return result;
        }

        private handlerResponded(response: any, params: any): any {
            response.data.requestParams = params;
            return response.data;
        }
    }
}